$(document).ready(function () {
    // OFI
    objectFitImages();

    /*
        GLOBAL
     */
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });


    if (window.location.hash != '') {
        const dest = $(window.location.hash);

        if (dest.length > 0) {
            $('html, body').animate({scrollTop: $(dest).offset().top});
        }

        return false;
    }

    if ($('.page-header-block').length > 0) {
        $(document).on('click', '.page-header-block .scroll-to-next', function () {
            $('html, body').animate({scrollTop: $('.page-header-block').innerHeight() + $('header#header').innerHeight()});
            return false;
        });
    }

    if ($('.pictos-carousel-block').length > 0) {
        $('.pictos-carousel-block .owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            nav: true,
            navText: ["<svg id=\"Groupe_30\" data-name=\"Groupe 30\" xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,4.149,4.392,0,8.785,4.149\" transform=\"translate(13.533 20.277) rotate(-90)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\"/>\n" +
            "  <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\">\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "  </g>\n" +
            "</svg>\n", "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <g id=\"Groupe_29\" data-name=\"Groupe 29\" transform=\"translate(-1375 -4039)\">\n" +
            "    <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,0,4.392,4.149,8.785,0\" transform=\"translate(1388.318 4059.277) rotate(-90)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\"/>\n" +
            "    <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" transform=\"translate(1375 4039)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\">\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "    </g>\n" +
            "  </g>\n" +
            "</svg>\n"],
            dots: false,
            autoplay: false,
            margin: 23,
            lazyLoad: true,
            responsive: {
                768: {
                    items: 2
                },
                991: {
                    items: 3
                }
            }
        });
    }

    if ($('.news-carousel-block').length > 0) {
        var news_carousel_owl = $('.news-carousel-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: ["<svg id=\"Groupe_30\" data-name=\"Groupe 30\" xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\">\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "  </g>\n" +
            "  <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,4.149,4.392,0,8.785,4.149\" transform=\"translate(13.533 20.277) rotate(-90)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\"/>\n" +
            "</svg>\n", "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <g id=\"Groupe_29\" data-name=\"Groupe 29\" transform=\"translate(-1375 -4039)\">\n" +
            "    <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" transform=\"translate(1375 4039)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\">\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "    </g>\n" +
            "    <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,0,4.392,4.149,8.785,0\" transform=\"translate(1388.318 4059.277) rotate(-90)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\"/>\n" +
            "  </g>\n" +
            "</svg>\n"],
            dots: false,
            autoplay: false,
            margin: 11,
            //lazyLoad: true,
            responsive: {
                768: {
                    items: 2,
                    stagePadding: 60
                },
                991: {
                    items: 3,
                    stagePadding: 100
                }
            }
        });

        $('.news-carousel-block .sites-filters-wrapper .sites-filters .site-filter').on('click', function () {
            const news_carousel_block = $(this).closest('.news-carousel-block');
            const site = $(this).data('site');
            let new_items = '';

            news_carousel_block.find('.all-items .item').each(function () {
                if ($(this).data('site') == site) {
                    new_items += $(this).prop('outerHTML');
                }
            });

            if (new_items == '')
                new_items = '<div>Aucune actualité</div>';

            news_carousel_owl.trigger('replace.owl.carousel', new_items);
            news_carousel_owl.trigger('refresh.owl.carousel');
            news_carousel_owl.trigger('load.owl.lazy');

            $('.news-carousel-block .sites-filters-wrapper .sites-filters .site-filter.active').removeClass('active');
            $(this).addClass('active');

            return false;
        });
    }

    if ($('.press-release-carousel-block').length > 0) {
        $('.press-release-carousel-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: ["<svg id=\"Groupe_30\" data-name=\"Groupe 30\" xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\">\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "  </g>\n" +
            "  <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,4.149,4.392,0,8.785,4.149\" transform=\"translate(13.533 20.277) rotate(-90)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\"/>\n" +
            "</svg>\n", "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <g id=\"Groupe_29\" data-name=\"Groupe 29\" transform=\"translate(-1375 -4039)\">\n" +
            "    <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" transform=\"translate(1375 4039)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\">\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "    </g>\n" +
            "    <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,0,4.392,4.149,8.785,0\" transform=\"translate(1388.318 4059.277) rotate(-90)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\"/>\n" +
            "  </g>\n" +
            "</svg>\n"],
            dots: false,
            autoplay: false,
            margin: 23,
            lazyLoad: true,
            responsive: {
                768: {
                    items: 2
                },
                991: {
                    items: 3
                }
            }
        });
    }


    $('.press-release-grid-block .sites-filters .site-filter').on('click', function () {
        const site = $(this).data('site');

        if ($(this).hasClass('active')) {
            $(this).closest('.press-release-grid-block').find('.items .item').each(function() {
                $(this).parent().removeClass('d-none');
            });

            $(this).removeClass('active');
        } else {
            $(this).closest('.press-release-grid-block').find('.items .item').each(function() {
                if ($(this).data('site') === site)
                    $(this).parent().removeClass('d-none');
                else
                    $(this).parent().addClass('d-none');
            });


            $(this).closest('.press-release-grid-block').find('.sites-filters .site-filter.active').removeClass('active');
            $(this).addClass('active');
        }

        return false;
    });


    if ($('#footer-other-sites').length > 0) {
        $('#footer-other-sites .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: ["<svg id=\"Groupe_30\" data-name=\"Groupe 30\" xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,4.149,4.392,0,8.785,4.149\" transform=\"translate(13.533 20.277) rotate(-90)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\"/>\n" +
            "  <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\">\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "    <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "  </g>\n" +
            "</svg>\n", "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\n" +
            "  <g id=\"Groupe_29\" data-name=\"Groupe 29\" transform=\"translate(-1375 -4039)\">\n" +
            "    <path id=\"Vector_3\" data-name=\"Vector 3\" d=\"M0,0,4.392,4.149,8.785,0\" transform=\"translate(1388.318 4059.277) rotate(-90)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\"/>\n" +
            "    <g id=\"Ellipse_1\" data-name=\"Ellipse 1\" transform=\"translate(1375 4039)\" fill=\"none\" stroke=\"#F06A50\" stroke-width=\"2\">\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" stroke=\"none\"/>\n" +
            "      <circle cx=\"15.5\" cy=\"15.5\" r=\"14.5\" fill=\"none\"/>\n" +
            "    </g>\n" +
            "  </g>\n" +
            "</svg>\n"],
            dots: false,
            autoplay: false,
            margin: 22,
            lazyLoad: true,
            responsive: {
                768: {
                    items: 2
                },
                991: {
                    items: 3
                }
            }
        });
    }

    $('.faq-block .search-wrapper .search-faq-input').on('keypress', function (e) {
        var key = e.which;
        if(key == 13)  // the enter key code
        {
            $(this).closest('.search-wrapper').find('.submit-search').click();
            return false;
        }
    });

    $('.faq-block .search-wrapper .submit-search').on('click', function () {
        const terms = $(this).closest('.search-wrapper').find('.search-faq-input').val().trim().toLowerCase();

        if (terms === '') {
            $(this).closest('.faq-block').find('.item').removeClass('d-none');
        } else {
            $(this).closest('.faq-block').find('.item').each(function () {
                const item_question = $(this).find('.item--question').text().trim().toLowerCase()
                const item_answer = $(this).find('.item--answer').text().trim().toLowerCase()

                if (item_question.includes(terms) || item_answer.includes(terms)) {
                    $(this).removeClass('d-none');
                } else {
                    $(this).addClass('d-none');
                }
            });
        }

        return false;
    });

    $('.steering-committees-list-block .submit-search').on('click', function () {
        const site = $(this).closest('.search-wrapper').find('.search-steering-site').val();
        const type = $(this).closest('.search-wrapper').find('.search-steering-type').val();

        console.log(site);
        console.log(type);

        if (site === '' && type === '') {
            $(this).closest('.steering-committees-list-block').find('.subsection--item').removeClass('d-none').closest('.subsection').removeClass('d-none');
            $(this).closest('.steering-committees-list-block').find('.site-wrapper').removeClass('d-none');
        } else {
            if (site === '') {
                $(this).closest('.steering-committees-list-block').find('.site-wrapper').removeClass('d-none');
            } else {
                $(this).closest('.steering-committees-list-block').find('.site-wrapper').each(function () {
                    console.log($(this).data('site'));
                    if ($(this).data('site') === site) {
                        $(this).removeClass('d-none');
                    } else {
                        $(this).addClass('d-none');
                    }
                });
            }

            if (type === '') {
                $(this).closest('.steering-committees-list-block').find('.subsection--item').removeClass('d-none').closest('.subsection').removeClass('d-none');
            } else {
                $(this).closest('.steering-committees-list-block').find('.subsection--item').each(function () {
                    if ($(this).data('type') === type) {
                        $(this).closest('.subsection').removeClass('d-none');
                        $(this).removeClass('d-none');
                    } else {
                        $(this).closest('.subsection').addClass('d-none');
                        $(this).addClass('d-none');
                    }
                });
            }
        }

        return false;
    });

});